"use strict";

/**
 * Sets general loader to html from it's template (generalLoaderTemplate).
 * Loader overlays complete screen.
 * Is removed with `hideGeneralLoader` method;
 */
window.showGeneralLoader = () => {
  const generalLoaderTemplate = document.querySelector('#generalLoaderTemplate');
  const generalLoader = generalLoaderTemplate.content.cloneNode(true);
  document.body.appendChild(generalLoader);
  document.querySelector('.belle_loader').style.display = 'grid';
};

/**
 * Removes general loader from DOM.
 */
window.hideGeneralLoader = () => {
  const generalLoader = document.querySelector('.belle_loader');
  if (generalLoader) generalLoader.remove();
};